module.exports = __webpack_public_path__ + "static/media/favicon.63ad1291.ico";